import request from "@/utils/request";

export function fetchPaymentHistory(schoolId, studentId) {
  return request({
    url: `/schools/${schoolId}/students/${studentId}/payment-history`,
    method: "get",
  });
}
